import React, {PureComponent} from 'react';

import {Classes, Overlay} from "@blueprintjs/core";

export default class PaymentMethodExpiredModal extends PureComponent {
    state = {
        overlayIsOpen: false,
        viberEnableRequests: '',
        testNumber: ''
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }

    componentDidMount() {
        this.setState({
            overlayIsOpen: this.props.showModal,
        })
    }

    componentDidUpdate() {
        if (this.state.overlayIsOpen !== this.props.showModal) {
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }
    }

    setTestNumber = (e) => {
        this.setState({testNumber: e.target.value})
    }

    render() {
        return (
            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER}
                isOpen={this.state.overlayIsOpen}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field text-center"
                     style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <div className="onboarding-panel viber-modal-container">
                        <p className="modal-close-button" onClick={() => {
                            this.props.handleClose()
                        }}><i className="fas fa-times"></i></p>

                        <h2>Your card has expired!</h2>


                        <div className="flex-row-wrapper margin-bottom-10" style={{width: '100%'}}>
                            <p className="full-row-label">Please add new card to payment methods or select different
                                card for workspace default payment option</p>

                        </div>

                        <div className="buttons-container text-center">

                            <button
                                className="btn-action dist-platf-button payment-method-btn"
                                disabled={false}
                                onClick={(e) => {
                                    e.preventDefault();
                                    window.location.href = '/billing/payment-methods';
                                }}>
                                Go to Payment Methods
                            </button>
                            {/*<a className='close-modal' onClick={() => {*/}
                            {/*    this.props.handleClose()*/}
                            {/*}}>*/}
                            {/*    or Don’t Run This Campaign*/}
                            {/*</a>*/}
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}